/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...



// Tabs
 $(document).ready(function() {


 $('nav.product-tabs__items').each(function(){

 var active, content, links = $(this).find('a');

 active = links.first().addClass('active');

 content = $(active.attr('href'));

 links.not(':first').each(function () {

 $($(this).attr('href')).hide();

 });

 $(this).find('a').click(function(e){

 active.removeClass('active');

 content.hide();

 active = $(this);

 content = $($(this).attr('href'));

 active.addClass('active');

 content.show();

 return false;

 });

 });
   
   
 $('#sub-2').hide();
   
// $('.enquiry-btn').click(function(){


//  return false;

// });


 });


if (document.body.id == "product-enquiry") {


var a = location.search.substring(1);
  if(document.getElementById("ContactFormSku")) {
  
  const input = document.getElementById("ContactFormSku");
  input.value = a;
  input.readOnly = true;
  
  
  }
}

// if(document.querySelector('.search-page__info__text')) {
   
//    const text = document.querySelector('.search-page__info__text');
// 	text.hidden = "true";
   
   
   
//    }



// Header
const header = document.querySelector('.header');
const headerElement = document.getElementById('shopify-section-announcement');

const callback = function (entries, observer) {
    if (entries[0].isIntersecting) {
      header.classList.remove('_scroll');
     
    } else {

      header.classList.add('_scroll');
     
    }
  };
                                              
                                              

 const headerObserver = new IntersectionObserver(callback);
 headerObserver.observe(headerElement);
   







